import React, { useEffect, useState } from 'react';
import useKidListFunctionality from '../../../customHooks/kidListHook';
import { setSelectedKidId, setDashboardLoader, setKidDevicesList, setSelectedDeviceData, deviceSelected } from '../../AxiosRtk/DashBoard';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import useSubscription from '../../../customHooks/subscriptionProvider';
import { setAddKidStatus } from '../../AxiosRtk/AddNewChild';
import useFirebase from '../../../../useFirebase';
import { isEmpty } from 'lodash';

const KidListContainer = ({ kidListing, getLangTranslation }) => {
  const [setupWizardData, setSetupWizardData] = useState(null);
  const [deviceData, setDeviceData] = useState(null);
  const history = useHistory();
  const { checkSubsciption } = useSubscription();
  const { dispatch, getImage } = useKidListFunctionality();
  const { getDeviceStatus, getCollectionData } = useFirebase();
  const [kid, setKid] = useState(null);
  const [isDeviceActive, setIsDeviceActive] = useState(-1);

  const {
    kidList,
    selectedKidId,
    kidDevicesList,
    dashboardLoader,
    
  } = useSelector(({ dashboard }) => dashboard);  

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  // Update selectedKidId and kid state dynamically
  useEffect(() => {
    if (selectedKidId) {
      dispatch(setKidDevicesList([]));
      const updatedKid = kidList?.find((item) => item?.ID === selectedKidId);
      setKid(updatedKid);
  
      // Optionally, check if selected kid has no devices and reflect that immediately
      if (!updatedKid?.KidsDevices?.length) {
        setIsDeviceActive(-1); // Or handle this visually
      }
    }
  }, [selectedKidId, kidList]);

  useEffect(() => {
    if (selectedKidId && kidDevicesList?.length === 0) {
      dispatch(setDashboardLoader(false)); // Stop loader when there's no device
    }
  }, [selectedKidId, kidDevicesList]);

  // Automatically select the first kid if no kid is selected
  useEffect(() => {
    if (!selectedKidId && kidListing?.length > 0) {
      dispatch(setSelectedKidId(kidListing[0]?.ID));
    }
  }, [kidListing, selectedKidId]);

  function handleAddDevice() {
    if (!checkSubsciption()) {
      return;
    }
    history.push('/connect-child-device');
    dispatch(setAddKidStatus('CONNECT_CHILD_DEVICE'));
  }

  useEffect(() => {
    if (kidDevicesList?.length > 0 && kidDevicesList[0]?.Name) {
      getCollectionData(kidDevicesList[0]?.ID);

      const promiseArr = kidDevicesList.map((item) =>
        getDeviceStatus(item?.ID)
      );

      Promise.all(promiseArr)
        .then((res) => {
          const isStatusTrueList = res.filter(
            (item) => item?.data?.deviceStatus === 1
          );
          setIsDeviceActive(isStatusTrueList?.length > 0 ? 1 : 0);
        })
        .catch((err) => console.log('Error fetching device status:', err));
    }
  }, [kidDevicesList]);

  useEffect(() => {
    if (!isEmpty(setRulesData)) {
      setSetupWizardData({ ...setRulesData?.setupWizard });
      const deviceId = setRulesData?.deviceId;
      const device = kidDevicesList?.find((item) => item?.ID === deviceId);
      setDeviceData(device);
    } else {
      setSetupWizardData(null);
    }
  }, [setRulesData, kidDevicesList]);

  function isSetupWizardCompleted() {
    if (!deviceData) {
      return true;
    }

    return deviceData?.isSetupWizardComplete === 1;
  }

  const handleKidSelection = (kidId) => {
    if (kidId !== selectedKidId) {
      dispatch(setDashboardLoader(true));
      dispatch(setSelectedKidId(kidId));
      dispatch(setSelectedDeviceData(null));
      dispatch(setKidDevicesList([])); // Add this line to clear previous device data
      setSetupWizardData(null);

      // Prepare payload
      const payload = {
        deviceId: deviceData?.ID ,
        isDeviceSelected: 1,
        kidId: kidId,
      };

      // Call API to update selected device
      if (payload) {
        deviceSelected(payload)
          .then((response) => {
            console.log('Device selection updated successfully', response.data);
          })
          .catch((error) => {
            console.error('Error updating device selection:', error);
          });
      } else {
        console.warn("Device ID is null, API will not be called!");
      }
    }
  };


  return (
    <div className="d-flex flex-wrap gap-9 mb-6">
      {kidListing?.map((item, index) => (
        <div
          className={`d-child-wrap ${selectedKidId === item?.ID ? 'active' : ''}`}
          key={index}
          onClick={() => {
            handleKidSelection(item?.ID);
          }}
          id={item?.ID}
        >
          <div className="d-child-thumb mx-auto ratio ratio-1x1 mb-3">
            <img
              src={getImage(item?.image, item?.gender)}
              alt=""
              className="img-fluid rounded-circle"
              onError={(event) => {
                event.target.onerror = null;
                event.target.src = getImage('', item?.gender);
              }}
            />

            {selectedKidId === item?.ID && (
              <Link to="/edit-child-profile" className="d-child-edit">
                <i className="icon-edit" />
              </Link>
            )}
          </div>
          {!dashboardLoader &&
            (item?.KidsDevices?.length === 0 ||
              !item?.KidsDevices[0]?.Name) && (
              <div>
                <span
                  className="text-pink-400 d-flex gap-1 align-items-center"
                  style={{ fontSize: '12px' }}
                >
                  <i className="icon-info text-pink-400 fs-6 c-pointer" />
                  {getLangTranslation(
                    'PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED',
                    'Device setup is not finished'
                  )}
                </span>
              </div>
            )}
          {isDeviceActive === 1 &&
            selectedKidId === item?.ID &&
            kidDevicesList?.length > 0 && (
              <div>
                <span
                  className="text-success d-flex justify-content-center gap-1 align-items-center"
                  style={{ fontSize: '12px', lineHeight: '10px' }}
                >
                  <i className="badge rounded-pill d-inline-block badge-sm bg-success" />
                  {getLangTranslation('CHILD_DEVICE_ACTIVE_NOW', 'Active Now')}
                </span>
              </div>
            )}
          {isDeviceActive === 0 &&
            selectedKidId === item?.ID &&
            kidDevicesList?.length > 0 && (
              <div>
                <span
                  className="text-secondary d-flex justify-content-center gap-1 align-items-center"
                  style={{ fontSize: '12px', lineHeight: '10px' }}
                >
                  <i className="badge rounded-pill d-inline-block badge-sm bg-gray-200" />
                  {getLangTranslation(
                    'CHILD_DEVICE_INACTIVE_NOW',
                    'Inactive Now'
                  )}
                </span>
              </div>
            )}
          {selectedKidId === item?.ID && !isSetupWizardCompleted() && (
            <div>
              <span
                className="text-pink-400 d-flex gap-1 align-items-center"
                style={{ fontSize: '12px' }}
              >
                <i className="icon-info text-pink-400 fs-6 c-pointer" />
                {getLangTranslation(
                  'PARENT_DASHBOARD_SETUP_WIZARD_NOT_DONE',
                  'Setup wizard not completed!'
                )}
              </span>
            </div>
          )}
          <h5>{item?.childName}</h5>
        </div>
      ))}
      {!dashboardLoader &&
        kidList?.length > 0 &&
        kidDevicesList?.length === 0 ? (
        <div className="col-md-12">
          <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3" role="alert">
            <i className="icon-info-octagon text-red-100 fs-5 c-pointer" />
            {`${getLangTranslation(
              'CHILD_DETAIL_PENDING_DEVICE_1',
              'You did not finish process of adding new device for'
            )} ${kid?.childName} ${getLangTranslation(
              'CHILD_DETAIL_PENDING_DEVICE_2',
              ', would like to continue now ?'
            )}`}
            <span className="light-text text-small">
              <button
                className="btn btn-outline-danger"
                onClick={handleAddDevice}
              >
                {getLangTranslation('SELECT_CHILD_CONTINUE', 'CONTINUE')}
              </button>
            </span>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        </div>
      ) : null}

      {!isSetupWizardCompleted() &&
        kidList?.length > 0 &&
        kidDevicesList?.length > 0 ? (
        <div className="col-md-12">
          <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3" role="alert">
            <i className="icon-info-octagon text-red-100 fs-5 c-pointer" />
            {`${getLangTranslation(
              'SETUP_WIZARD_NOT_COMPLETE_DEVICE_INFO',
              "You did not complete the process of setup wizard for the device '$DEVICE_NAME$' of child '$CHILD_NAME$'"
            )
              ?.replace('$DEVICE_NAME$', deviceData?.Name)
              ?.replace('$CHILD_NAME$', kid?.childName)} ${getLangTranslation(
                'CHILD_DETAIL_PENDING_DEVICE_2',
                ', would like to continue now ?'
              )}`}
            <span className="light-text text-small">
              <button
                className="btn btn-outline-danger"
                onClick={() => history.push('/setup-wizard')}
              >
                {getLangTranslation('SELECT_CHILD_CONTINUE', 'CONTINUE')}
              </button>
            </span>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default KidListContainer;
